/**
 * Euro.
 */
export var EUR = {
  code: 'EUR',
  base: 10,
  exponent: 2
};